<template>
  <Modal ref="modalRef" position="end">
    <template #header>{{ title }}</template>
    <template #body>
      <View direction="column" gap="md">
        <Hint v-if="hint" icon="info-circle">{{ hint }}</Hint>
        <component :is="form" ref="formRef" v-bind="formProps" />
      </View>
    </template>
    <template #footer>
      <Button variant="ghost" @click="modalRef?.close()">Cancel</Button>
      <Button :loading="formRef?.form?.submitting" :disabled="formRef?.isBusy" @click="save">Save</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { type Component, ref } from 'vue';

import { Button, Hint, Modal, View } from '@tallo/design-system';

/** The edit sheet of a building section: the same form a property uses, with a hint on what a save reaches */
defineProps<{
  title: string;
  /** Said at the top of the sheet, for what a save does and does not reach */
  hint?: string;
  form: Component;
  /** Props for the form, e.g. which part of the building basics a card edits */
  formProps?: Record<string, unknown>;
}>();

const modalRef = ref<InstanceType<typeof Modal>>();
const formRef = ref<{ save: () => Promise<unknown>; form?: { submitting: boolean }; isBusy?: boolean }>();

function show() {
  modalRef.value?.show();
}

// A save that fails keeps the sheet open, with the form's own errors on it
async function save() {
  await formRef.value?.save();
  modalRef.value?.close();
}

defineExpose({ show });
</script>
